import { lazy, memo, Suspense } from "react";

const ReactQueryDevtools = lazy(() =>
  process.env.NODE_ENV === "development"
    ? import("@tanstack/react-query-devtools").then((mod) => ({
        default: mod.ReactQueryDevtools,
      }))
    : Promise.resolve({ default: () => null }),
);

export const TanStackQueryDevtools = memo(function TanStackDevtools() {
  const shouldShowDevtools =
    process.env.NODE_ENV === "development" &&
    new URLSearchParams(window.location.search).get("tanstack") === "query";

  if (!shouldShowDevtools) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools
        buttonPosition="bottom-right"
        initialIsOpen={false}
        position="bottom"
      />
    </Suspense>
  );
});
